/* eslint-disable react/no-danger */
import React from 'react'
import {
  formatDateToRender,
  formatDateWithTimeToRender,
} from 'src/common/types'
import { InfoTable } from 'src/components/InfoTable'
import { richTextDefaultText } from 'src/components/RichTextEditor'
import { Tag } from 'src/components/Tag'
import { UserHyperlink } from 'src/components/UserHyperlink'
import { SurvivorPurchaseTodoData } from 'src/store/APIs/purchaseTodos/types'

import { strings } from '../strings'

interface ViewPurchaseTodoProps {
  data?: SurvivorPurchaseTodoData
}

export const ViewPurchaseTodo: React.FC<ViewPurchaseTodoProps> = ({ data }) => {
  const products =
    data?.retail_products?.map(product => product.name) ?? undefined

  const rows = [
    {
      content: data?.todo,
      label: strings.todoLabel,
    },
    {
      content:
        data?.description && data?.description !== richTextDefaultText ? (
          <div dangerouslySetInnerHTML={{ __html: data?.description }} />
        ) : undefined,
      label: strings.descriptionLabel,
    },
    {
      content: data?.completed ? (
        <Tag color="blue">{strings.tagYes}</Tag>
      ) : (
        <Tag color="default">{strings.tagNo}</Tag>
      ),
      label: strings.completedColumnLabel,
    },
    {
      content: formatDateWithTimeToRender(data?.due_datetime),
      label: strings.dueDateColumnLabel,
    },
    {
      content: data?.created_by ? (
        <UserHyperlink user={data?.created_by} />
      ) : undefined,
      label: strings.createdByLabel,
    },
    {
      content: data?.completed_by ? (
        <UserHyperlink user={data?.completed_by} />
      ) : undefined,
      label: strings.completedByLabel,
    },
    {
      content: formatDateToRender(data?.completed_date),
      label: strings.completedDateColumnLabel,
    },
    {
      content: data?.deleted_by ? (
        <UserHyperlink user={data?.deleted_by} />
      ) : undefined,
      label: strings.discardedByLabel,
    },
    {
      content: products?.join(', '),
      label: strings.retailProductsColumnLabel,
    },
  ]

  return <InfoTable rows={rows} contentStyle={{ width: '75%' }} />
}
